<template>
  <div class="tableWrap">
    <el-table :data="itemList" border size="small" class="wdb100">
      <el-table-column prop="category" label="Category" align="center" width="158px">
        <template slot-scope="scope">
          <span>{{ invoiceItemCategoryFormat(scope.row.category) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="description" label="Description" align="center" min-width="200px"></el-table-column>
      <el-table-column prop="originalCurrency" label="Currency" align="center" width="100px"></el-table-column>
      <el-table-column prop="originalAmount" label="Orig. Amount" align="center" width="180px">
        <template slot-scope="scope">
          <span>{{ currencyAndAmountFormat(scope.row.originalCurrency, scope.row.originalAmount) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="exchangeRate" label="Ex Rate" align="center" width="180px"></el-table-column>
      <el-table-column prop="billingAmount" label="Amount" align="center" width="180px">
        <template slot-scope="scope">
          <span>{{ currencyAndAmountFormat(billingCurrency, scope.row.billingAmount) }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import formatterMixin from "@/mixins/formatterMixin";
import { mapState } from "vuex";
export default {
  mixins: [formatterMixin],
  props: {
    itemList: {
      type: Array,
      default: () => [],
    },
    bankAccountIds: {
      type: Array,
      default: () => [],
    },
    supplierBankAccountList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapState("currency", ["currencyList"]),
    billingCurrency() {
      // 第一个银行的币种作为开票币种
      const firstBankAccountId = this.bankAccountIds[0];
      const currency = this.supplierBankAccountList.find(item => item.id == firstBankAccountId)?.billingCurrency;
      return currency || "";
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.tableWrap {
  padding: 6px 120px 6px 22px;
}
</style>
